;(function () {
	function initUgcPins(section) {
		var pinWraps = section.querySelectorAll(".js-ucg-pin-wrap")

		function closeAll() {
			pinWraps.forEach(function (wrap) {
				wrap.classList.remove("is-active")
			})
			document.body.classList.remove("is-ucg-detail-open")
		}

		pinWraps.forEach(function (wrap) {
			var pin = wrap.querySelector(".js-ucg-pin")
			if (!pin) return

			pin.addEventListener("click", function (e) {
				e.stopPropagation()
				var isOpen = wrap.classList.contains("is-active")

				closeAll()

				if (!isOpen) {
					wrap.classList.add("is-active")
					document.body.classList.add("is-ucg-detail-open")
				}
			})
		})

		document.addEventListener("click", function (e) {
			if (!document.body.classList.contains("is-ucg-detail-open")) return

			var activeWrap = section.querySelector(".js-ucg-pin-wrap.is-active")
			if (activeWrap && !activeWrap.contains(e.target)) {
				closeAll()
			}
		})
	}

	document.addEventListener("DOMContentLoaded", function () {
		document
			.querySelectorAll(".shopify-section--ugc-carousel")
			.forEach(function (section) {
				initUgcPins(section)
			})
	})
})()
